/* eslint-disable no-restricted-syntax */
/* eslint-disable import/extensions */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Alert,
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';

import { environment } from '../../../enviroment/enviroment';
import apiResponseHandler from 'utils/apiResponseHandler';

/**
 * @summary Render Add Branch Modal component
 *
 * @param {object} props The components' props
 * @returns {Component}
 */
const EditBranchModal = (props) => {
  const [state, setState] = useState({
    errors: [],
    formError: false,
    editBranchPayload: {
      branchName: '',
      branchCode: '',
    },
    triedSubmitting: false,
  });
  const {
    toggleEditBranchModal,
    handleShowEditBranchModal,
    branch,
    getEmployerData,
  } = props;

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      editBranchPayload: {
        branchName: branch.name,
        branchCode: branch.code,
      },
    }));
  }, [branch]);

  const validatePayload = (payload) => {
    const errors = [];

    if (payload.name?.trim() === '' || payload.name === undefined) {
      errors.push('Updated branch name must have a value');
    }

    if (payload.code?.trim() === '' || payload?.code === undefined) {
      errors.push('Updated branch code must have a value.');
    }

    setState({
      ...state,
      errors: errors,
      formError: errors.length > 0,
      triedSubmitting: true,
    });

    return errors.length < 1;
  };

  const handleSubmitEditModal = (e) => {
    e.preventDefault();
    // eslint-disable-next-line no-shadow
    const { editBranchPayload } = state;
    // eslint-disable-next-line no-shadow
    const { branch } = props;

    let payload = {
      name: editBranchPayload.branchName,
      code: editBranchPayload.branchCode,
    };

    const url = `${environment.baseUrl}/branches/${branch.id}/`;

    if (validatePayload(payload)) {
      axios
        .patch(url, payload)
        .then((res) => {
          Swal.fire({
            title: 'Branch updated successfully',
            text: res.alert_message ? res.alert_message : '',
            icon: 'success',
            toast: true,
            position: 'top',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
          });
          handleShowEditBranchModal();
          getEmployerData();
        })
        .catch((error) => {
          apiResponseHandler.handleApiError('Error', error);
        });
    }
  };

  const handleInputChange = (event) => {
    setState({
      ...state,
      editBranchPayload: {
        ...state.editBranchPayload,
        [event.target.name]: event.target.value,
      },
    });
  };

  const { errors, formError, triedSubmitting, editBranchPayload } = state;
  return (
    <>
      <Modal isOpen={toggleEditBranchModal}>
        <ModalHeader>Update Branch</ModalHeader>
        <ModalBody>
          {formError && errors && (
            <Alert color="danger">
              {errors.map((error) => {
                return <li key={error}>{error}</li>;
              })}
            </Alert>
          )}

          <Form>
            <FormGroup>
              <Label for="branchName" sm={6} className="required-input">
                Name
              </Label>
              <Col sm={12}>
                <Input
                  type="text"
                  name="branchName"
                  id="branchName"
                  defaultValue={branch.name}
                  onChange={(event) => handleInputChange(event)}
                  invalid={
                    triedSubmitting && !editBranchPayload.branchName.trim()
                  }
                />
              </Col>
            </FormGroup>
            <FormGroup>
              <Label for="branchCode" sm={6} className="required-input">
                Branch Code
              </Label>
              <Col sm={12}>
                <Input
                  type="text"
                  name="branchCode"
                  id="branchCode"
                  defaultValue={branch.code}
                  onChange={(event) => handleInputChange(event)}
                  invalid={
                    triedSubmitting && !editBranchPayload.branchCode.trim()
                  }
                />
              </Col>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmitEditModal}>
            Save
          </Button>{' '}
          <Button color="secondary" onClick={handleShowEditBranchModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

EditBranchModal.defaultProps = {};

EditBranchModal.propTypes = {
  toggleEditBranchModal: PropTypes.func.isRequired,
};

export default EditBranchModal;
